import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";

const ApproveModal = ({ show, handleClose, title, approvFunc }) => {
  return (
    <Modal centered show={show} onHide={handleClose} dialogClassName="my-modal">
      <ModalBody>
        <div className="p-2">
          <p className="fn_Nunito fw_700 fs_18 color_262c3d my-2 px-0">
            Are you sure ?
          </p>
          <p className="fn_Nunito fw_400 fs_16 color_747f9e my-2 px-0">
            Do you want to approve this {title}
          </p>
          <div className="d-flex justify-content-between">
            <AdminButton
              width="150px"
              background="#2AD3E7"
              color="white"
              onClick={() => approvFunc()}
            >
              <span className="m-2">APPROVE</span>
            </AdminButton>
            <AdminButton
              width="150px"
              background="#7065e4"
              color="white"
              onClick={() => handleClose()}
            >
              <span className="m-2">NO</span>
            </AdminButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ApproveModal;
